// Copyright (c) 2019 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// Constants
export {
  KEPLER_GL_VERSION,
  KEPLER_GL_WEBSITE,
  KEPLER_GL_NAME,
  DIMENSIONS,
  ALL_FIELD_TYPES,
  FIELD_OPTS,
  FILTER_TYPES,
  GEOJSON_FIELDS,
  ICON_FIELDS,
  TRIP_POINT_FIELDS,
  TRIP_ARC_FIELDS,
  SCALE_TYPES,
  LAYER_TYPES,
  LAYER_BLENDINGS,
  AGGREGATION_TYPES,
  MAX_DEFAULT_TOOLTIPS,
  DATA_TABLE_ID,
  DELETE_DATA_ID,
  ADD_DATA_ID,
  EXPORT_IMAGE_ID,
  EXPORT_DATA_ID,
  EXPORT_MAP_ID,
  ADD_MAP_STYLE_ID,
  DEFAULT_LAYER_GROUPS,
  DEFAULT_MAP_STYLES,
  THEME,
  EXPORT_MAP_FORMATS,
  EXPORT_MAP_FORMAT_OPTIONS,
  EXPORT_DATA_TYPE_OPTIONS,
  DEFAULT_NOTIFICATION_TYPES,
  DEFAULT_NOTIFICATION_TOPICS,
  DEFAULT_COLOR_RANGE,
  PANELS
} from './default-settings';

export {
  GITHUB_BUG_REPORT,
  GITHUB_USER_GUIDE
} from './user-guides';

export {VizColorPalette, DataVizColors} from './custom-color-ranges';
export {COLOR_RANGES, DefaultColorRange} from './color-ranges';
